import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { faqs } from '@/mocks/home';
import { SITE_NAME, SITE_ORIGIN } from '@/lib/site';
import HeroSection from './components/HeroSection';
import SpeedFeatures from './components/SpeedFeatures';
import FeaturedSection from './components/FeaturedSection';
import CategoryBrowse from './components/CategoryBrowse';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import BrandSection from './components/BrandSection';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: SITE_NAME,
    url: SITE_ORIGIN,
    description: '看料社是聚合全网热门爆料与吃瓜现场的极速超清观看门户，主打高清不卡顿的流畅播放体验。',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: SITE_NAME,
    url: SITE_ORIGIN,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_ORIGIN}/category?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: { '@type': 'Answer', text: faq.a },
    })),
  },
];

export default function Home() {
  useSeo({
    title: '在线看料 - 高清不卡顿秒开，在线看料流畅极速超清 - 看料社',
    description:
      '在线看料就上看料社，高清不卡顿秒开，全网热门爆料视频与吃瓜现场实时同步，超清画质加载快，看料不等待，流畅到飞起。在线看料流畅、高清、不卡顿、秒开的极速观看体验。',
    keywords: '在线看料,在线看料流畅,在线看料高清,在线看料不卡顿,在线看料秒开,在线看料极速',
    path: '/',
    jsonLd: homeJsonLd,
  });

  return (
    <SiteLayout>
      <HeroSection />
      <SpeedFeatures />
      <FeaturedSection />
      <CategoryBrowse />
      <RankingSection />
      <FaqSection />
      <BrandSection />
    </SiteLayout>
  );
}